import React from "react";
import {
    Grid,
    Box,
    InputLabel,
    Select,
    useTheme,
    useMediaQuery,
    Typography,
    makeStyles
} from '@material-ui/core';

import { taxData } from '../../../core/calculatorData';
import {
    useCalculator,
    DISPATCH_UPDATE_YEAR,
} from '../../../state/calculatorState';
import { useLayout, UPDATE_LAYOUT } from '../../../state/layoutState';
import {
    StyledFormControl,
} from '../../common/CustomComponents';
import { getTaxYearIndex, getCurrentTaxYearIndex } from '../../../core/calculatorUtils';
import { HOURLY, payOptions } from "../../../core/calculatorConstants";

const useStyles = makeStyles(theme => {
    return {
        active: {
            width:'100%',

            '& .MuiSelect-root': {
            backgroundColor: theme.palette.primary.main,
            },

            '& .MuiInputLabel-root': {
                color: theme.palette.primary.contrastText,
                fontWeight: 700,
            },
            '& .MuiSelect-underline:before, .MuiFilledInput-underline:before': {
                borderColor: theme.palette.primary.light,
            },
        },
        inactive: {
            width:'100%'
        },
    }
});


export const SummaryOptions = () => {
    const classes = useStyles();
    const theme = useTheme();
    const small = useMediaQuery(theme.breakpoints.down('md'));

    const [{ year }, dispatchCalculator] = useCalculator();
    const [{ resultsRange }, dispatchLayout] = useLayout();


    const handleChangeFrequency = () => event => {
        return (
            dispatchLayout({
                type: UPDATE_LAYOUT,
                data: { resultsRange: event.target.value }
            })
        )
    }


    const handleChangeYear = () => event => {
        return (
            dispatchCalculator({
                type: DISPATCH_UPDATE_YEAR,
                year: taxData[event.target.value].year,
            })
        )
    }

    const yearIndex = getTaxYearIndex(year);
    const yearIndexCurrent = getCurrentTaxYearIndex();
    const estimate = taxData[yearIndex].estimate

    // take all the payOptions except for the hourly scale
    const payOptionsList = payOptions.filter(option => option.title !== HOURLY);

    if (!small) return false;

    return (
        <Grid container spacing={2} style={{ alignItems: "flex-start" }}>
            <Grid item xs={5}>

                <Box style={{ position: "relative" }}>
                    <StyledFormControl variant="filled" className = {yearIndex === yearIndexCurrent ? classes.inactive : classes.active}>
                        <InputLabel aria-label="Tax year" htmlFor="Tax year">Tax Year</InputLabel>
                        <Select
                            native
                            variant="filled"
                            id="Tax year"
                            aria-label="Select Tax year"
                            aria-labelledby="Tax year"
                            onChange={handleChangeYear()}
                            value={yearIndex}
                        >
                            {taxData.map((option, index) => (
                                <option
                                    key={option.year + " " + index}
                                    data={option.year}
                                    value={index}
                                    aria-label={"Select " + index}
                                    aria-labelledby="Tax year"
                                    style={{ color: (index === yearIndexCurrent ? theme.palette.primary.contrastText : theme.palette.secondary.main) }}
                                >
                                    {`${Number(option.year) - 1} - ${Number(option.year) - 2000} ${option.estimate ? "*" : ""}`}
                                </option>
                            ))}
                        </Select>
                    </StyledFormControl>

                </Box>
            </Grid>

            <Grid item xs={7}>

                <StyledFormControl variant="filled" style={{ paddingLeft: 5, width: '100%' }}>
                    <InputLabel htmlFor="frequency">Pay Frequency</InputLabel>
                    <Select
                        native
                        variant="filled"
                        id="frequency"
                        onChange={handleChangeFrequency()}
                        value={resultsRange}
                    >
                        {payOptionsList.map((option, index) => (
                            <option
                                key={option.title}
                                data={option}
                                value={index}
                            >
                                {option.title}
                            </option>
                        ))}
                    </Select>
                </StyledFormControl>
            </Grid>
            {estimate && (
                <Grid item xs={12} style={{ padding: 0, paddingLeft: 20, marginTop: -5 }}>
                    <Typography variant="body2" style={{ opacity: 0.6 }}>* This is an estimate</Typography>
                </Grid>
            )}
        </Grid >

    );
}

export default SummaryOptions;